import { createContext, useContext } from "react";
import { Meeting, Invitation } from "@/components/types";
import { getInvitationIdentifier } from "conference/components/joinMeetingTools";
import { SipSettings, createSIPUri } from "@dvrt/web-phone-client";
import { clientIdParamName, getClientIdentifier } from "../tools";
import { groupChatIdPrefix } from "../room/tools";

export class CurrentMeeting {
    readonly invitations: Invitation[];
    readonly meeting: Meeting;

    constructor(meeting: Meeting, invitations: Invitation[]) {
        this.meeting = meeting;
        this.invitations = invitations;
    }

    get selfIdentifier() {
        return getInvitationIdentifier(this.invitations);
    }

    get selfInvitation() {
        const id = this.selfIdentifier;
        return this.invitations.filter((i) => i.uuid === id)[0];
    }

    get selfSipUserAuth(): SipSettings["auth"] {
        return {
            identifier: this.selfInvitation.id.toString(),
            domainName: window.tequet.mixerDomain,
            uriParams: {
                [clientIdParamName]: getClientIdentifier(),
            },
        };
    }

    get chatRoomId() {
        return `${groupChatIdPrefix}${this.meeting.id}@${window.tequet.mixerDomain}`;
    }

    get selfUri() {
        return createSIPUri(this.selfSipUserAuth);
    }

    getInvitationById(id: number) {
        return this.invitations.filter((i) => i.id === id)[0];
    }

    getDisplayName(invitation: Invitation) {
        let name = invitation.name;

        if (name === "Host" || name === "General") name = "";

        if (name === "") name = invitation.email || invitation.phoneNumber || "";

        return name === "" ? null : name;
    }
}

export const CurrentMeetingContext = createContext(undefined);

export const useCurrentMeeting = (): CurrentMeeting => useContext(CurrentMeetingContext);
